import * as React from 'react';
import VideoPlayer from 'react-video-js-player';
import { VideoJsPlayer } from 'video.js'
import autobind from 'autobind-decorator';
import '../Assets/video.sass';

export interface IVideoProps {
  videoFile: string;
  videoStartTime: number;
}

export interface IVideoState {
}

export default class Video extends React.Component<IVideoProps, IVideoState> {
  private player: VideoJsPlayer;
  constructor(props: IVideoProps) {
    super(props);
    this.state = {

    }
  }
  onPlayerReady(player) {
    console.log("Player is ready: ", player);
    this.player = player;
    this.player.currentTime(this.props.videoStartTime);
    this.player.addRemoteTextTrack({
      label: "English",
      src: "/media/static/video/a.srt",
      srclang: "en",
      default: true
    }, false)
  }

  onVideoPlay(duration) {
    console.log("Video played at: ", duration);
  }

  onVideoPause(duration) {
    console.log("Video paused at: ", duration);
  }

  onVideoTimeUpdate(duration) {
    console.log("Time updated: ", duration);
  }

  onVideoSeeking(duration) {
    console.log("Video seeking: ", duration);
  }

  onVideoSeeked(from, to) {
    console.log(`Video seeked from ${from} to ${to}`);
  }

  onVideoEnd() {
    console.log("Video ended");
  }


  componentDidUpdate(oldProps: IVideoProps) {
    if (oldProps.videoStartTime !== this.props.videoStartTime) {
      this.player.currentTime(this.props.videoStartTime);
      this.player.pause();
    }
  }

  customPlay() {
    this.player.play();
  }

  customPause() {
    this.player.pause();
  }

  getCurrentTime() {
    return this.player.currentTime();
  }

  public render() {
    return (
      <div>
        <VideoPlayer
          controls={true}
          src={this.props.videoFile}
          height="480"
          bigPlayButtonCentered={false}
          className="video-react-component"
          onReady={this.onPlayerReady.bind(this)}
          onPlay={this.onVideoPlay.bind(this)}
          onPause={this.onVideoPause.bind(this)}
          onTimeUpdate={this.onVideoTimeUpdate.bind(this)}
          onSeeking={this.onVideoSeeking.bind(this)}
          onSeeked={this.onVideoSeeked.bind(this)}
          onEnd={this.onVideoEnd.bind(this)}
        />

      </div>
    );
  }
}
